const handleGoLink = (link: string) => {
  try {
    const url = `https://${link}`;
    window.open(url, "_blank");
  } catch (error) {}
};

export default handleGoLink;
